module.exports = __webpack_public_path__ + "static/media/node.19370d00.png";